import React, {Component, Fragment} from "react";
import axios from "axios";
import { SVG } from '@svgdotjs/svg.js'
import CloseIcon from "../icons/CloseIcon";
import ChevronRight from "../icons/ChevronRight";
import ChevronLeft from "../icons/ChevronLeft";

import Flickity from "react-flickity-component";
import ProductSliderTile from "./ProductSliderTile";

class InsectCalendar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            facts: null,
            title: '',
            selectedFact: null,
        }

        this.calendarHolder = React.createRef();
        this.relatedSlider = React.createRef();
        this.svg = null;
        this.width = 800;
        this.height = 800;
        this.margin = 50;
        this.outerCircle = this.width - (this.margin * 2);
        this.radius = this.width / 2;
        this.gutter = 35;
        this.month = [
            'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'
        ];
        this.monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
        ];

        this.lineHeight = (this.width - (this.margin + this.gutter)) / 2;
        this.labelDistance = (this.width - (this.margin)) / 2;
        this.strokeColor = '#74C4E4';


        this.selectFact = this.selectFact.bind(this);
        this.closeFact = this.closeFact.bind(this);
        this.relatedListLeft = this.relatedListLeft.bind(this);
        this.relatedListRight = this.relatedListRight.bind(this);
    }


    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log('updated');
    }

    loadData()
    {
        axios.get(this.props.endpoint).then((response) => {
            this.setState({
                facts: response.data.facts,
                title: response.data.title
            }, () => {
                this.drawCalendar();
            });
        });
    }

    selectFact(selectedFact)
    {
        this.setState({
            selectedFact: selectedFact
        })
    }

    closeFact()
    {
        this.setState({
            selectedFact: null
        })
    }

    drawCalendar()
    {
        if (this.calendarHolder.current) {
            const dom = this.calendarHolder.current;

            this.svg = SVG().addTo(this.calendarHolder.current)
                .size(this.width, this.height);

            this.svg.viewbox(0, 0, this.width, this.height);

            const outerCircle = this.svg.circle(this.outerCircle).center(
                this.width / 2,
                this.height / 2
            ).stroke({
                width: 1,
                color: this.strokeColor,
            }).fill({color: 'transparent'});

            this.drawLines();

            const spaceBetween = this.outerCircle / (this.state.facts.length + 1);
            const orderedFacts = [...this.state.facts].reverse();
            for (let i = 1; i <= orderedFacts.length; i++) {
                const fact = orderedFacts[i - 1];
                const cw = spaceBetween * i;

                const guideCircle = this.svg.circle(cw)
                    .center(this.width / 2, this.height / 2)
                    .stroke({
                        width: 1,
                        color: this.strokeColor,
                    })
                    .fill({color: 'transparent'});

                const fRadius = cw / 2;
                const fX = this.radius;
                const fY = this.radius;
                const fStartAngle = fact.start * 30;
                const fEndAngle = fact.end * 30;
                ////
                const fStart = this.polarToCartesian(fX, fY, fRadius, fEndAngle);
                const fEnd = this.polarToCartesian(fX, fY, fRadius, fStartAngle);
                const arcSweep = fEndAngle - fStartAngle <= 180 ? "0" : "1";
                const d = [
                    "M", fStart.x, fStart.y,
                    "A", fRadius, fRadius, 0, arcSweep, 0, fEnd.x, fEnd.y
                ].join(' ');

                const path = this.svg.path(d).fill({color: 'transparent'})
                    .stroke({
                        width: 44,
                        color: '#FFFFFF',
                    });
                path.node.classList.add('fact-path');
                path.node.addEventListener('click', () => {
                    this.selectFact(fact);
                });

                if (fact.label) {
                    const lStartAngle = fact.start * 30 - (10/i * fact.label.length);
                    const lEndAngle = fact.start * 30 - 2;
                    const lStart = this.polarToCartesian(fX, fY, fRadius + 7, lEndAngle);
                    const lEnd = this.polarToCartesian(fX, fY, fRadius + 7, lStartAngle);
                    const lArcSweep = lEndAngle - lStartAngle <= 180 ? "0" : "1";
                    const dL = [
                        "M", lStart.x, lStart.y,
                        "A", fRadius + 7, fRadius + 7, 0, lArcSweep, 0, lEnd.x, lEnd.y
                    ].join(' ');
                    const p = this.svg.textPath(fact.label, dL);
                    p.node.classList.add('fact-label');
                }
            }
        }
    }


    drawLines() {
        const step = (2 * Math.PI) / 12;
        let angle = 0;
        for (let i = 0; i < 12; i++) {

            const x = Math.round(this.width/2 + this.lineHeight * Math.cos(angle));
            const y = Math.round(this.height/2 + this.lineHeight * Math.sin(angle));

            const d = [
                "M", this.width / 2, this.height / 2,
                "L", x, y
            ].join(' ');
            this.svg.path(d).stroke({ width: 1, color: this.strokeColor });

            const tStartAngle = 30 * i - 2;
            const tEndAngle = 30 * i + 2;
            const fStart = this.polarToCartesian(this.radius, this.radius, this.labelDistance, tEndAngle);
            const fEnd = this.polarToCartesian(this.radius, this.radius, this.labelDistance, tStartAngle);
            const arcSweep = tEndAngle - tStartAngle <= 180 ? "0" : "1";
            const textPath = [
                "M", fStart.x, fStart.y,
                "A", this.labelDistance, this.labelDistance, 0, arcSweep, 0, fEnd.x, fEnd.y
            ].join(' ');

            this.svg.textPath(this.month[i], textPath);

            angle += step;
        }
    }


    degreesToRadeins(degrees) {
        const pi = Math.PI;
        return degrees * pi / 180;
    }

    polarToCartesian(centerX, centerY, radius, angleInDegrees) {
        const angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;
        return {
            x: centerX + (radius * Math.cos(angleInRadians)),
            y: centerY + (radius * Math.sin(angleInRadians))
        };
    }

    relatedListRight()
    {
        if (this.relatedSlider.current) {
            const slider = this.relatedSlider.current;
            if (slider.flkty) {
                slider.flkty.next();
            }
        }
    }

    relatedListLeft()
    {
        if (this.relatedSlider.current) {
            const slider = this.relatedSlider.current;
            if (slider.flkty) {
                slider.flkty.previous();
            }
        }
    }

    render() {
        if (!this.state.facts) {
            return '';
        }

        return <Fragment>

            <div className="insect-page__mobile-list block md:hidden">
                <div className="insect-page__mobile-list__header">
                    <h3>{this.state.title} Key Dates</h3>
                </div>
                {this.state.facts.map((fact) => {
                    return <div className="insect-page__mobile-list__fact" key={'mobile-fact__' + fact.id}>
                        <h3>{fact.title}</h3>
                        <p>{this.monthNames[fact.start]} through {this.monthNames[fact.end]}</p>
                        <a href={'#'}
                           className="btn btn--blue btn--blue--solid"
                           onClick={(e) => {e.preventDefault(); this.selectFact(fact); }}>
                            Find out more
                        </a>
                    </div>
                })}
            </div>


            <div className="insect-page__calendar__inner  hidden md:block">
                <h1>{this.state.title} Key Dates</h1>
                <div className="insect-page__calendar__svg" ref={this.calendarHolder} />
            </div>

            {!!this.state.selectedFact && <Fragment>
                <div className="insect-page__calendar__popup">
                    <div className="insect-page__calendar__popup__inner">
                        <div className="container">
                            <div className="container--">
                                <div className="insect-page__calendar__popup__close" onClick={this.closeFact}>
                                    <CloseIcon />
                                </div>
                                <div className="insect-page__calendar__popup__scroll">
                                    <h3>
                                        {this.state.selectedFact.title}
                                    </h3>
                                    <div className="insect-page__calendar__popup__main">
                                        <div className="insect-page__calendar__popup__body">
                                            <div dangerouslySetInnerHTML={{__html: this.state.selectedFact.content}}>
                                            </div>
                                            {!!this.state.selectedFact.action_link && <p>
                                                <a className="btn btn--blue btn--blue--solid" href={this.state.selectedFact.action_link}
                                                    target={this.state.selectedFact.action_target}>
                                                    {this.state.selectedFact.action_title}
                                                </a>
                                            </p>}
                                        </div>
                                        <div className="insect-page__calendar__popup__image">
                                            {!!this.state.selectedFact.image && <img src={this.state.selectedFact.image} alt={this.state.selectedFact.title} />}
                                        </div>
                                    </div>
                                    {!!this.state.selectedFact.products.length > 0 &&
                                        <div className='insect-page__calendar__popup__related'>
                                            <h3>Related Products</h3>
                                            <div className="insect-page__calendar__popup__related-list">
                                                <Flickity ref={this.relatedSlider} options={{cellAlign: 'left', pageDots: true, contain: true, prevNextButtons: false}}>
                                                    {this.state.selectedFact.products.map((product) => {
                                                        return <ProductSliderTile product={product} />
                                                    })}
                                                </Flickity>
                                                <div className="insect-page__calendar__popup__buttons">
                                                    <a onClick={this.relatedListLeft}>
                                                        <ChevronLeft />
                                                    </a>
                                                    <a onClick={this.relatedListRight}>
                                                        <ChevronRight />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="insect-page__calendar__popup__bg" onClick={this.closeFact}></div>
                </div>
            </Fragment>}

        </Fragment>

    }


}


export default InsectCalendar;
